import React, { useState } from 'react'
import { Modal, ModalBody, ModalHeader, Tooltip } from 'reactstrap'
import { useLocation } from 'react-router'
import { Form, Field } from 'react-final-form'
import { Button, Input, InputError, InputLabel, Select, Textarea, Topography } from 'components/ui'
import { getSnapshot, Validators } from 'utils'
import { useDispatch } from 'react-redux'
import { reportBug } from 'store/actions/auth.action'
import Alert from 'components/ui/Alert/Alert';
import styles from './Footer.module.scss'
import { sendSnapshot } from 'store/actions/paymentMethods'

interface PropTypes {
    className?: string
}


const pages = [
    {
        url: /^\/dashboard$/,
        name: 'Dashboard',
        id: '001'
    },
    {
        url: /^\/profile$/,
        name: 'Profile',
        id: '001'
    },
    {
        url: /^\/subscription$/,
        name: 'Subscription',
        id: '001'
    },
    {
        url: /\/add-payment$/,
        name: 'Add Payment',
        id: '001'
    },
    {
        url: /^\/dependents$/,
        name: 'Dependents',
        id: '001'
    },
    {
        url: /^\/dependents\/add$/,
        name: 'Add Dependent',
        id: '001'
    },
    {
        url: /^\/dependents\/[\d]+\/timeline$/,
        name: 'Dependent Timeline',
        id: '001'
    },
    {
        url: /^\/dependents\/[\d]+\/details$/,
        name: 'Dependent Detail',
        id: '001'
    },
    {
        url: /^\/support$/,
        name: 'Support',
        id: '001'
    },
    {
        url: /^\/request-refund$/,
        name: 'Request Refund',
        id: '001'
    },
    {
        url: /^\/request-status$/,
        name: 'Request Status',
        id: '001'
    },
    {
        url: /^\/records-and-forms$/,
        name: 'Records and Forms',
        id: '001'
    },
    {
        url: /^\/request-detail\/[\d]+$/,
        name: 'Request Detail',
        id: '001'
    },
    {
        url: /^\/record-request\/provider$/,
        name: 'Record Request - Provider',
        id: '001'
    },
    {
        url: /^\/record-request\/patient$/,
        name: 'Record Request - Patient',
        id: '001'
    },
    {
        url: /^\/record-request\/create-patient$/,
        name: 'Record Request - Add Patient',
        id: '001'
    },
    {
        url: /^\/record-request\/date$/,
        name: 'Record Request - Date',
        id: '001'
    },
    {
        url: /^\/record-request\/auth-type$/,
        name: 'Record Request - Auth Type',
        id: '001'
    },
    {
        url: /^\/record-request\/authorization$/,
        name: 'Record Request - Authorization',
        id: '001'
    },
    {
        url: /^\/record-request\/request-info$/,
        name: 'Record Request - Request Info',
        id: '001'
    },
    {
        url: /^\/record-request\/payment$/,
        name: 'Record Request - Payment',
        id: '001'
    },
    {
        url: /^\/record-request\/confirm$/,
        name: 'Record Request - Confirm',
        id: '001'
    },
    {
        url: /^\/record-request\/requestConfirmed$/,
        name: 'Record Request - Request Confirmation',
        id: '001'
    },
    {
        url: /^\/form-request\/provider$/,
        name: 'Form Request - Provider',
        id: '001'
    },
    {
        url: /^\/form-request\/patient$/,
        name: 'Form Request - Patient',
        id: '001'
    },
    {
        url: /^\/form-request\/create-patient$/,
        name: 'Form Request - Add Patient',
        id: '001'
    },
    {
        url: /^\/form-request\/type$/,
        name: 'Form Request - Type',
        id: '001'
    },
    {
        url: /^\/form-request\/upload-type$/,
        name: 'Form Request - Upload Type',
        id: '001'
    },
    {
        url: /^\/form-request\/auth-type$/,
        name: 'Form Request - Auth Type',
        id: '001'
    },
    {
        url: /^\/form-request\/authorization$/,
        name: 'Form Request - Authorization',
        id: '001'
    },
    {
        url: /^\/form-request\/request-info$/,
        name: 'Form Request - Request Info',
        id: '001'
    },
    {
        url: /^\/form-request\/payment$/,
        name: 'Form Request - Payment',
        id: '001'
    },
    {
        url: /^\/form-request\/confirm$/,
        name: 'Form Request - Confirm',
        id: '001'
    },
    {
        url: /^\/form-request\/requestConfirmed$/,
        name: 'Form Request - Request Confirmation',
        id: '001'
    },
]
const reasons = ['Application working slowly', 'Application is no longer responding', 'Application is not functioning as expected', 'I have a suggestion', 'Something else']


export const Footer: React.FC<PropTypes> = ({ className }) => {
    const route: any = useLocation()
    const dispatch = useDispatch()
    const win: any = window

    const [isModalOpen, setModalOpen] = useState(false)
    const [isSaving, setSaving] = useState(false)
    const [response, setResponse] = useState<any>(null)
    const [isTooltipOpen, setTooltipOpen] = useState<boolean>(false)

    const toggleModal = () => {
        if (isModalOpen) setModalOpen(!isModalOpen)
        else getSnapshot(base64 => {
            dispatch(sendSnapshot(base64, 'Help_Desk'))
        })
        setModalOpen(!isModalOpen)
    }

    const pageIndex = pages.findIndex(i => i.url.test(route.pathname)) + 1
    const temp = '000' + pageIndex.toString()
    const pageId = 'P-2' + temp.slice(temp.length - 3)

    const handleSubmit = (values: any) => {
        let fd = new FormData()
        fd.append('title', values.title?.value)
        fd.append('comment', values.comment)
        fd.append('unique_identifier_number', pageId)
        setSaving(true)
        setResponse(null)
        dispatch(reportBug(fd, (error, message) => {
            setSaving(false)
            setResponse({ error, message })
            if (!error) setModalOpen(false)
            setTimeout(() => setResponse(null), 5000)
        }))
    }
    const handleSupportClick = () => {
        if (win?.Beacon) {
            win.Beacon('open')
            toggleModal()
        }
    }

    return (<>
        {response && !response.error && <Alert type={'success'} className={styles.alert}>{response?.message}</Alert>}
        <div className={className}>
            {pageIndex > 0 && (<div style={{ fontSize: '14px' }}>
                <b role='button' onClick={toggleModal} id='pageId'>Provide Feedback</b>
                <Tooltip placement="top" target='pageId' isOpen={isTooltipOpen} toggle={() => setTooltipOpen(isTooltipOpen => !isTooltipOpen)}>Leave us a message about your experience.</Tooltip>
            </div>)}
            <Modal centered isOpen={isModalOpen} toggle={toggleModal}>
                <ModalBody>
                    <Form onSubmit={handleSubmit} render={({ handleSubmit, hasValidationErrors }) => (
                        <form onSubmit={handleSubmit} className='row'>
                            <div className='col'>
                                <Topography.H4>Help Desk</Topography.H4>
                            </div>
                            <div className='col-auto'>
                                <span className='text-primary' role='button' onClick={handleSupportClick}>Support</span>
                            </div>
                            <Field name='title' validate={Validators.required}>
                                {({ input, meta }) => (
                                    <div className='col-12 mt-3 border-top pt-3'>
                                        <InputLabel text='What kind of issue are you experiencing?' />
                                        <Select {...input} options={reasons.map((item) => ({ label: item, value: item }))} />
                                        {meta.error && meta.touched && <InputError>{meta.error}</InputError>}
                                    </div>
                                )}
                            </Field>
                            <Field name='comment' validate={Validators.required}>
                                {({ input, meta }) => (
                                    <div className='col-12 mt-3'>
                                        <InputLabel text='Please tell us more about your issue' />
                                        <Textarea {...input} type="textarea" hasError={meta.error && meta.touched} />
                                        {meta.error && meta.touched && <InputError>{meta.error}</InputError>}
                                    </div>
                                )}
                            </Field>
                            <div className='col-12'>
                                {response?.error && <Alert type={'error'} className='mt-3'>{response?.message}</Alert>}
                            </div>

                            <div className='col-auto mt-3'>
                                <Button className='w-auto px-4' onClick={toggleModal}>Cancel</Button>
                            </div>
                            <div className='col-auto mt-3 ml-auto'>
                                <Button disabled={hasValidationErrors || isSaving} htmlType="submit" className='w-auto px-4'>{isSaving ? 'Submitting' : 'Submit'}</Button>
                            </div>
                        </form>
                    )} />
                </ModalBody>
            </Modal>
        </div>
    </>)
}